module.exports = __webpack_public_path__ + "static/img/icon_luckywheel.aa28fb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_luckywheel.svg
// module id = HEng
// module chunks = 0